import { api } from 'src/plugins/axios'
import { createQueryString, serializeObject } from 'src/utils'

export default {
  fetch,
  fetchClass,
  generateCertificates,
  print,
  changeShippingType,
}

async function fetch({ commit, state }, { pagination, filter, columns, customFilter, exportOptions }) {
  commit('isLoading')
  try {
    let fieldQuery
    const query = createQueryString({ pagination, filter, columns, customFilter, exportOptions })
    let searchFields = { ...state.searchFields }

    let finalSearchFields = _.pickBy(searchFields, v => {
      return v !== null && v !== '' && (typeof v === 'string' ? v.trim() !== '' : 1)
    })
    if (!_.isEmpty(finalSearchFields)) {
      fieldQuery = serializeObject({searchFields: {...finalSearchFields}})
    }
    let finalQuery = query + (fieldQuery ? '&' + fieldQuery : '')

    const { data: response } = await api.get('/certificates/fetch/' + finalQuery)
    const { success, payload } = response

    commit('doneLoading')
    state.selectedCertificates = []
    if (!success) throw response
    if (!exportOptions) commit('setList', { certificates: payload.certificates })

    return response
  } catch (response) {
    commit('doneLoading')
    return response
  }
}

async function fetchClass({ commit, rootState }, { pagination, filter, columns, customFilter, exportOptions }) {
  let classId = rootState.classes.sessionInformation.classId
  try {
    const query = createQueryString({ pagination, filter, columns, customFilter, exportOptions })
    const { data: response } = await api.get('/certificates/fetchClass/' + query + "&classId=" + classId)
    const { success, payload } = response
    if (!success) throw response
    if (!exportOptions) rootState.classes.sessionInformation.certificates = payload.certificates

    return response
  } catch (response) {
    commit('doneLoading')
    return response
  }
}

async function generateCertificates({ commit, state }) {
  commit('isLoadingCertificates')
  try {
    const certificateIds = state.selectedCertificates.map(certificate => certificate.CERTIFICATE_ID)
    const data = await api.post('/certificates/generateCertificates', certificateIds, { responseType: 'blob' })
    commit('doneLoadingCertificates')
    return data
  } catch (response) {
    commit('doneLoadingCertificates')
    return response
  }
}

async function print({ commit, state }, { certificateIds, }) {
  commit('isLoading')
  try {
    const { data: response } = await api.post('/certificates/print/', { certificateIds })
    state.selectedCertificates = []

    return response
  } catch (err) {
    return err
  } finally {
    commit('doneLoading')
  }
}

async function changeShippingType({ commit, state }, { overnight_ind, certificateIds, }) {
  commit('isLoading')
  try {
    const { data: response } = await api.post('/certificates/changeShippingType/', {
      overnight_ind,
      certificateIds,
    })
    state.selectedCertificates = []

    return response
  } catch (err) {
    return err
  } finally {
    commit('doneLoading')
  }
}
